module.exports = __webpack_public_path__ + "static/logo-main-ef4b144c4f643490eec2347339ec4576.png";